export const setAsComplexLogic = () => {
  /**
   * @param allCartItems {array}
   * @param forPartId {string}
   * @param currentQuote {number}
   * @param freeItemsCount {number}
   * @param featurePrice {number}
   * @param forCartItem {object}
   * @param forQuantity {number}
   * @returns {number}
   **/
  window.calculateAsFeatureCost = (allCartItems = [],
                                   forPartId = "",
                                   currentQuote = 0,
                                   freeItemsCount = 2,
                                   featurePrice = 0,
                                   forCartItem = null,
                                   forQuantity = 0) => {
    const filteredCartItems = (allCartItems || []).filter(cItem => {
      return (cItem.currentQuote === currentQuote) && (cItem.partId === forPartId) && cItem.complexLogic
    });
    let totalQuantity = filteredCartItems.reduce((sum, item) => sum + item.quantity, 0);
    if (forCartItem) {
      let remainingFree = Math.min(freeItemsCount, totalQuantity); // First two items are free
      let finalPrice = 0;
      for (let item of filteredCartItems) {
        let freeItems = Math.min(item.quantity, remainingFree);
        let paidItems = item.quantity - freeItems;
        if (item.cartItemId === forCartItem.cartItemId) {
          finalPrice = paidItems * featurePrice;
          break;
        }
        remainingFree -= freeItems;
      }
      return finalPrice
    } else {
      const megaTotal = totalQuantity + forQuantity; // already added + this one
      return totalQuantity >= freeItemsCount
        ? forQuantity * featurePrice // already more than 2! calculate each separately now
        : megaTotal <= freeItemsCount
          ? 0 // included (cases when 1 added + 1 current)
          : (megaTotal - freeItemsCount) * featurePrice
    }
  }
}
